import React from 'react';
import {Navbar, Nav} from 'react-bootstrap';
import './App.css';
import MainComponent from './mainComponent.js'
import logo from './assets/logo.jpeg'

const App = () => (
  <div>
    <Navbar className="custom-navbar" expand="lg">
      <img src={logo} id="brand_logo"/>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="ml-auto">
          <Nav.Link href="#flow" className="custom-nav-link">Why Us?</Nav.Link>
          <Nav.Link href="#benefits" className="custom-nav-link">Features</Nav.Link>
          <Nav.Link href="#mentor-header" className="custom-nav-link">Mentors</Nav.Link>
          <Nav.Link href="#resources" className="custom-nav-link">Resources</Nav.Link>
          <button type="button" className="btn custom-button" data-toggle="modal" data-target="#exampleModal">
            Get in touch
          </button>
        </Nav>
        
      </Navbar.Collapse>
    </Navbar>

    <MainComponent />

    <footer id="footer">
      <p className="text-center mt-2"><b>Email :</b> <a className="text-white" href="mailto:trainthetrainer8286@gmail.com">trainthetrainer8286@gmail.com</a></p>
      <p className="text-center">Copyright &copy; Teach Our Teachers 2020</p>
    </footer>


  </div>
);

export default App
